import { trackRetailerMobileSidebarAccountDropdownClick } from "@faire/web-api/events/retailerMobile/click/sidebarAccountDropdown";
import { getDocumentOrThrow } from "@faire/web/common/globals/getDocument";
import { useCallback, useEffect } from "react";

import { useHeaderStore } from "@faire/retailer/components/Header/HeaderStoreProvider";

import { topNavEvent } from "./Events";

export const useHeaderState = () => {
  const [
    {
      isSearchVisible,
      isShowingAccountMenu,
      isShowingMenu,
      isShowingMobileSearch,
      query,
    },
    setHeaderStore,
  ] = useHeaderStore([
    "isShowingAccountMenu",
    "isSearchVisible",
    "query",
    "isShowingMobileSearch",
    "isShowingMenu",
  ]);

  const showMenu = useCallback(() => {
    setHeaderStore({
      isShowingMenu: true,
    });
    getDocumentOrThrow().body.classList.add("noscroll");
  }, [setHeaderStore]);

  const hideMenu = useCallback(() => {
    setHeaderStore({
      isShowingMenu: false,
    });
    getDocumentOrThrow().body.classList.remove("noscroll");
  }, [setHeaderStore]);

  const toggleAccountMenu = useCallback(() => {
    topNavEvent("account")();
    setHeaderStore({
      isShowingAccountMenu: !isShowingAccountMenu,
    });
    trackRetailerMobileSidebarAccountDropdownClick();
  }, [isShowingAccountMenu, setHeaderStore]);

  const showMobileSearch = useCallback(() => {
    setHeaderStore({
      isShowingMobileSearch: true,
      isSearchVisible: true,
    });
  }, [setHeaderStore]);

  const hideMobileSearch = useCallback(() => {
    setHeaderStore({
      isShowingMobileSearch: false,
    });
  }, [setHeaderStore]);

  const clearSearchQuery = useCallback(() => {
    setHeaderStore({
      query: "",
    });
  }, [setHeaderStore]);

  const showSearchQuery = useCallback(() => {
    setHeaderStore({ isSearchVisible: true });
  }, [setHeaderStore]);

  const hideSearchQuery = useCallback(() => {
    setHeaderStore({ isSearchVisible: false });
  }, [setHeaderStore]);

  const setSearchQuery = useCallback(
    (query: string) => {
      setHeaderStore({
        query,
      });
    },
    [setHeaderStore]
  );

  useEffect(() => {
    if (!isSearchVisible) {
      hideMobileSearch();
    }
  }, [hideMobileSearch, isSearchVisible]);

  return {
    isShowingMenu,
    isShowingMobileSearch,
    isShowingAccountMenu,
    isSearchVisible,
    query,
    showMenu,
    hideMenu,
    toggleAccountMenu,
    showMobileSearch,
    hideMobileSearch,
    clearSearchQuery,
    setSearchQuery,
    showSearchQuery,
    hideSearchQuery,
  };
};
